export default "__VITE_ASSET__XusVQtD3__"